module.exports = __webpack_public_path__ + "static/img/BI.f4f8a98c.svg";